import { useSearchParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import PageMeta from "../components/PageMeta";
import Footer from "../components/Footer";
import FloatingFAQ from "../components/FloatingFAQ";
import ConsultationForm from "../components/ConsultationForm";

export default function Consultation() {
  const [searchParams] = useSearchParams();
  const serviceParam = searchParams.get("service");

  return (
    <div className="noise-bg">
      <PageMeta
        title="Book a Free Consultation | Averoan Technologies"
        description="Book a free 30-minute consultation call. Tell us about your project and get a clear plan and quote."
      />
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-8 relative" data-testid="consultation-hero">
        <div className="hero-glow absolute top-0 right-0 opacity-30" />
        <div className="container-main relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <span className="tag mb-6">Free Consultation Available</span>
            <h1
              className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6"
              style={{ fontFamily: '"Clash Display", sans-serif' }}
            >
              Let's get <span style={{ color: '#D4FF00' }}>started</span>
            </h1>
            <p className="text-base md:text-lg" style={{ color: '#A1A1AA' }}>
              Tell us about your project. You can also book a free 30-minute consultation call.
            </p>
          </div>
        </div>
      </section>

      {/* Form */}
      <section className="py-8 md:py-12" data-testid="consultation-form-section">
        <div className="container-main">
          <ConsultationForm preSelectedServiceId={serviceParam} />
        </div>
      </section>

      <Footer />
      <FloatingFAQ />
    </div>
  );
}
